<template>
  <div class="mt-5 mt-lg-0">
    <section class="fw-bold d-flex align-items-center">
      CVS:
      <input type="file" class="form-control ms-3" accept=".csv" @change="onChange($event)"/>
      <div v-show="parsed" class="my-4">
        <button class="btn btn-success btn-sm" @click="sendTasks()">
          Wyślij dane CVS do bazy
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import Papa from 'papaparse'
import Swal from 'sweetalert2'
export default {
  name: 'CsvParser',
  data () {
    return {
      file: '',
      content: [],
      parsed: false,
      exportable: [],
      failed: []
    }
  },
  methods: {
    onChange (event) {
      this.file = event.target.files[0]
      this.parseFile()
    },
    sendTasks () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}Tasks`, {
        tasks: this.exportable
      }, config).then(() => {
        if (this.failed.length > 0) {
          const failedTasksVrids = this.failed.join(', ')
          Swal.fire({
            title: 'Wystąpiły błędy w niektórych zleceniach',
            html: `<div class="text-danger">${failedTasksVrids}</div>`,
            icon: 'warning'
          })
        } else {
          Swal.fire('Zaimportowano cały plik cvs', '', 'success')
        }
      }).catch(e => {
        if (e.response.status === 500) {
          Swal.fire('Wystąpił błąd w pliku CSV, prosimy sprawdzić, czy numery VRID w pliku się nie powtarzają', '', 'error')
        } else {
          Swal.fire('Nie udało się zaimportować pliku', '', 'error')
        }
      })
    },
    createExportable (collection) {
      for (const rowIndex in collection) {
        if (collection[rowIndex][2] === 'Identyfikator VR' || collection[rowIndex][0] === 'VRID' || collection[rowIndex][2] === '') {
          continue
        }

        const stops = [
          {
            acronym: collection[rowIndex][19],
            przyjazd: collection[rowIndex][20],
            wyjazd: collection[rowIndex][21]
          },
          {
            acronym: collection[rowIndex][22],
            przyjazd: collection[rowIndex][23],
            wyjazd: collection[rowIndex][24]
          },
          {
            acronym: collection[rowIndex][25],
            przyjazd: collection[rowIndex][26],
            wyjazd: collection[rowIndex][27]
          },
          {
            acronym: collection[rowIndex][28],
            przyjazd: collection[rowIndex][29],
            wyjazd: collection[rowIndex][30]
          },
          {
            acronym: collection[rowIndex][31],
            przyjazd: collection[rowIndex][32],
            wyjazd: collection[rowIndex][33]
          },
          {
            acronym: collection[rowIndex][34],
            przyjazd: collection[rowIndex][35],
            wyjazd: collection[rowIndex][36]
          },
          {
            acronym: collection[rowIndex][37],
            przyjazd: collection[rowIndex][38],
            wyjazd: collection[rowIndex][39]
          },
          {
            acronym: collection[rowIndex][40],
            przyjazd: collection[rowIndex][41],
            wyjazd: collection[rowIndex][42]
          },
          {
            acronym: collection[rowIndex][43],
            przyjazd: collection[rowIndex][44],
            wyjazd: collection[rowIndex][45]
          },
          {
            acronym: collection[rowIndex][46],
            przyjazd: collection[rowIndex][47],
            wyjazd: collection[rowIndex][48]
          }
        ]
        let failed = false
        let errorMessage = 'Przyczyna błędu nieznana'

        const task = {
          textColor: '#000000',
          backgroundColor: '#ffffff',
          numer_Przejazdu: collection[rowIndex][2],
          przewoznik: collection[rowIndex][9],
          linia: collection[rowIndex][5],
          szacunkowy_Koszt: !collection[rowIndex][15] ? 0 : parseFloat(collection[rowIndex][15]),
          postoje: []
        }
        for (const stop in stops) {
          if (stops[stop].acronym !== '' && stops[stop].przyjazd !== '') {
            if (stops[stop].wyjazd === '') {
              stops[stop].wyjazd = stop.przyjazd
            }
            task.postoje.push(stops[stop])
          }
        }
        if (typeof task.numer_Przejazdu !== 'undefined') {
          const failedStoppages = task.postoje.filter(stoppage => isNaN(new Date(stoppage.przyjazd)))

          if (failedStoppages.length === 0) {
            this.exportable.push(task)
          } else {
            failed = true
            errorMessage = 'Błąd formatu pliku: błędne dane postoi lub nieprawidłowa kolejność kolumn'
          }
        }

        if (failed) {
          this.failed.push(`${task.numer_Przejazdu}:${errorMessage}`)
        }
      }
    },
    parseFile () {
      Papa.parse(this.file, {
        header: false,
        skipEmptyLines: true,
        complete: function (results) {
          this.content = results
          this.parsed = true
          this.createExportable(this.content.data)
        }.bind(this)
      })
    }
  }
}
</script>

<style scoped>
.text-sm {
  font-size: .8rem;
}
</style>
